import { useState, useEffect, useCallback } from 'react';
import { adminService } from '../services/adminService';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        await adminService.getMe();
        setIsAuthenticated(true);
      } catch {
        localStorage.removeItem('access_token');
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (username: string, password: string) => {
    try {
      const tokenData = await adminService.login({ username, password });
      localStorage.setItem('access_token', tokenData.access_token);
      setIsAuthenticated(true);
    } catch (error: any) {
      console.error('Login error details:', {
        message: error?.message,
        response: error?.response?.data,
        status: error?.response?.status,
      });
      throw error;
    }
  };

  const logout = () => {
    adminService.logout();
    setIsAuthenticated(false);
  };

  return { isAuthenticated, isLoading, login, logout, checkAuth };
};
